/* unplugin-vue-components disabled */import script from "./StatusBar.vue?vue&type=script&setup=true&lang=js"
export * from "./StatusBar.vue?vue&type=script&setup=true&lang=js"

import "./StatusBar.vue?vue&type=style&index=0&id=1f0990fe&lang=scss"

const __exports__ = script;

export default __exports__